<script>

export default {
  name: 'AppListLayout'
}
</script>

<template lang="pug" src="./AppListLayout.pug"></template>
